export * from './util-angular.js';
export * from './shop-angular.js';

// Load in the contentStack configMaps used by ns-common-angularjs
import {getConfiguration} from '@nuskin/configuration-sdk';
import {events} from '@nuskin/ns-util';

const configMapsToLoad = ['Url', 'Checkout'];

const caRunConfigCallback = (runConfig) => {
    if (runConfig && typeof runConfig.clientId === 'string') {
        events.unsubscribe(events.global.RUN_CONFIG_CHANGED, caRunConfigCallback);
        getConfiguration(configMapsToLoad).then(() => console.log('ns-common-angularjs config loaded'));
    }
}

events.getValue(events.global.RUN_CONFIG_CHANGED, caRunConfigCallback, true);